<template>
	<div class="pages">
		<div class="navTitle flex flex-align-center">
			<div @click="changeType(1)" class="navTitle-item" :class="{'navTitle-itemActive': type == 1}">广场</div>
			<div @click="changeType(2)" class="navTitle-item" :class="{'navTitle-itemActive': type == 2}">关注</div>
		</div>
		<van-list
			v-model="loading"	
			:finished="finished"
			:immediate-check="false"
			finished-text="没有更多了"
			@load="onLoad"
			:offset="10"
		>
			<div class="friendsList">
				<template v-for="(item, index) in dataList">					
					<div @click="toDetail(item.id)" v-if="item.type == 2" :key="item.id" class="friendsItem flex" >
						<img :src="item.avatar" class="avatar" />
						<div class="right flex-1 flex flex-column">
							<div class="name">{{item.nickname}}</div>
							<div class="time">{{item.time}}</div>
							<div class="content">{{item.brief}}</div>
							<div class="imgList flex flex-align-center flex-jus-between flex-wrap">
								<videoItem :content="''" :cover="item.pic" :width="148" :height="111" :videoSrc="item.content"></videoItem>
							</div>

							<div class="infoStatus flex flex-row-reverse">
								<div class="flex flex-align-center">
									<img src="@/static/images/my/message.png" class="icon" />
									<div>{{item.comment_num}}</div>
								</div>

								<div class="flex flex-align-center" style="margin-right: 20px;">
									<img v-if="item.is_likes == 1" @click.stop="doLikes(item.id,index)" src="../../static/images/index/good_yes.png" class="icon" />
									<img v-else @click.stop="doLikes(item.id,index)" src="../../static/images/index/good.png" class="icon" />
									<div>{{item.likes_num}}</div>
								</div>
							</div>
						</div>
					</div>
					<div @click="toDetail(item.id)" v-if="item.type == 1" :key="item.id" class="friendsItem flex">
						<img :src="item.avatar" class="avatar" />
						<div class="right flex-1 flex flex-column">
							<div class="name">{{item.nickname}}</div>
							<div class="time">{{item.time}}</div>
							<div class="content">{{item.brief}}</div>
							<div class="imgList flex flex-align-center flex-jus-between flex-wrap">
								<img @click.stop="openImg(item.content, cIndex)" v-for="(cItem, cIndex) in item.content" :key="cIndex" :src="cItem" alt="" />
							</div>

							<div class="infoStatus flex flex-row-reverse">
								<div class="flex flex-align-center">
									<img src="@/static/images/my/message.png" class="icon" />
									<div>{{item.comment_num}}</div>
								</div>

								<div class="flex flex-align-center" style="margin-right: 20px;">
									<img v-if="item.is_likes == 1" @click.stop="doLikes(item.id, index)" src="../../static/images/index/good_yes.png" class="icon" />
									<img v-else @click.stop="doLikes(item.id, index)" src="../../static/images/index/good.png" class="icon" />
									<div>{{item.likes_num}}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</van-list>
		<tabbar :tabbar="1"></tabbar>
		<van-image-preview v-model="showImg" :images="imagesArr" :startPosition="startPosition">
    </van-image-preview>
	</div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
	components: {
		videoItem
	},
	data() {
		return {
			type: '1', // 1 广场  2 关注
			page: 1,
			loading: false,
      finished: false,
      dataList: [],

			showImg: false,
			imagesArr: [],
			startPosition: 0
		};
	},
	created() {
		this.getList()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '友圈',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		changeType(type) {
			this.type = type
			this.dataList = []
			this.page = 1
			this.getList()
		},
		getList(page = 0) {
			this.$get('api/circle/getCiecleList', {
				type: this.type,
				pageSize: 10,
				page: page || this.page
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        // this.dataList = this.dataList.concat(rows);
				let num = page || this.page
				this.dataList.splice((num - 1)*10, 10, ...rows)
			})
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
		doLikes(id, index) {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
        return
			}
			this.$post('api/actile/doLikes', {
				type: 2,
				article_id: id
			}).then(() => {
				this.getList(Math.ceil(index / 10))
			})
		},
		toDetail(id) {
			this.$router.push({name: 'circleDetail', query: {id}})
		},
		openImg(data, index) {
			this.imagesArr = data
			this.showImg = true
			this.startPosition = index
		}
	}
};
</script>

<style scoped lang="stylus">
.pages
	background-color #FFFFFF
	min-height 100vh
	padding-bottom 150px
.friendsList
	margin-top 94px
	padding 0 30px
	.friendsItem
		padding-top 44px
		.avatar
			width 84px
			height 84px
			border-radius 50%
		.name
			width 100%
			font-size 28px
			font-weight bold
			color #000000
		.time
			width 100%
			margin-top 8px
			font-size 22px
			color #979797
		.content
			margin-top 24px
			margin-bottom 28px
			width 100%
			font-size 26px
			color #000000
		.imgList
			img
				width 186px
				height 186px
				border-radius 20px
				margin-bottom 10px
				object-fit cover
		.imgList:after
			content ''
			display inline-block
			width 186px
		.right
			margin-left 24px
			border-bottom 2px solid #ECECEC
		.infoStatus
			margin-top 40px
			margin-bottom 40px
			font-size 26px
			color #000000
			.icon
				width 32px
				height 32px
				margin-right 8px
.navTitle
	position fixed
	top 0
	left 0
	padding 0 32px
	width 100%
	border-bottom 2px solid #E2E2E2
	height 94px
	// position relative
	background-color #FFFFFF
	z-index 10001
	.navTitle-item
		font-size 28px
		color #000000
		margin-right 80px
	.navTitle-itemActive
		font-size 36px
		font-weight 800
		color #DE113C
		position relative
		&::after
			content ' '
			position absolute
			left 0
			bottom -24px
			width 100%
			height 6px
			background #DE113C
</style>
